import withRouter from '../../utils/withRouter';
import turbo from '../components/UI/Images/inmold.svg';
import './Header.css';
import UserOptions from './Settings/UserOptions';
import UserAvatar from '../components/UI/UserAvatar/UserAvatar';
import useHttp from '../hooks/use-http';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setLanguageCookie } from '../../utils/languageCookie';
import NotificationBell from '../components/UI/Notifications/NotificationBell';
import useNotifications from './Notifications/useNotifications';

function Header() {
  const { sendRequest } = useHttp('');
  const { sendRequest: getLanguages, data: langData } = useHttp('');
  const { i18n } = useTranslation();
  const {
    userNotifications,
    unreadNotifications,
    unreadOnly,
    handleUnreadFilterChange,
    handleReadNotification,
    handleOpenNotification,
    handleReadAllNotifications,
    refreshNotifications,
  } = useNotifications();

  useEffect(() => {
    const config = {
      url: 'Combo/vrati_opcije_menija_pretraga',
      method: 'POST',
      data: { id: +localStorage.idMenija },
    };
    sendRequest(config);

    const configLang = {
      url: `combo/vrati_jezike_za_prevod_combo`,
    };
    getLanguages(configLang);
  }, []);

  const handleLanguageChange = (event) => {
    console.log(event.target.value);
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
    setLanguageCookie(selectedLanguage);
  };
  return (
    <div className="header">
      <img
        src={turbo}
        alt="myInmold"
        style={{
          height: '28px',
          width: '119px',
          marginLeft: '5px',
        }}
      />

      <div
        style={{ display: 'flex', marginRight: '15px', alignItems: 'center' }}
      >
        <select
          onChange={handleLanguageChange}
          value={i18n.language}
          style={{
            width: '100px',
            border: 'none',
            padding: '8px',
            borderRadius: '5px',
            backgroundColor: '#f0f0f0',
            color: '#333',
            cursor: 'pointer',
            outline: 'none',
            marginRight: '20px',
          }}
        >
          {langData?.map((item) => {
            return (
              <option key={item.vrednost} value={item.vrednost}>
                {item.vrednost}
              </option>
            );
          })}
        </select>
        <NotificationBell
          unreadNotifications={unreadNotifications}
          userNotifications={userNotifications}
          onRead={handleReadNotification}
          onOpenDetails={handleOpenNotification}
          onReadAll={handleReadAllNotifications}
          unreadOnly={unreadOnly}
          onUnreadFilterChange={handleUnreadFilterChange}
          onOpen={refreshNotifications}
        />
        <UserAvatar
          user={localStorage.korinik}
          imageUrl="null"
          boja={localStorage.boja}
        />
        <span className="user-name">{localStorage.korisnik}</span>

        <UserOptions>
          <button className="header-options">
            <i className="fas fa-chevron-down" />
          </button>
        </UserOptions>
      </div>
    </div>
  );
}

export default withRouter(Header);
